import {get, set} from 'lodash';

const konfiguration = (state = {}, action) => {

  switch (action.type) {

    case 'KONFIGURATION': {

      if ( action.wert === null) {
        let newstate = {...state };
        if (get(state, action.pfad)) {
          set(newstate, action.pfad, false)
          return newstate
          break;
        } else {
          set(newstate, action.pfad, true)
          return newstate
          break;
        }
      }

      if ( get(state, action.pfad) ===  action.wert) {
        return state
        break;
      } else {
        let newstate = {...state };
        set(newstate, action.pfad, action.wert)
        return (newstate)
        break;
      }
    }

    default: {
      return state
    }
  }

}

export default konfiguration;